import { cn } from '@/lib/utils'

export function Card({ className, children }: { className?: string; children?: React.ReactNode }) {
  return (
    <div
      className={cn(
        'px-4 py-5 border border-gold/30 bg-black/30 rounded-lg backdrop-blur-sm',
        className,
      )}
    >
      {children}
    </div>
  )
}
